import React, {Component} from 'react';
import {getUnitID, getUnitLiveStreamStatus, getUnitLiveStreamURL} from "../utils";
import {isReady, isRecording, isStarting} from "./utils";
import {getRecordingType} from "../../recording/utils";
import Throbber from "../../miscellaneous/Throbber";
import {dbase} from "../../../firebase";
import {byPropKey} from "../../utils";

/**
 * Live view tab wrapper
 */
class LiveViewTab extends Component {
    constructor() {
        super();
        this.state = {
            viewStateReady: false,
            error: ""
        };
    }

    componentWillMount() {
        if (isReady(this.props.selectedUnit)) {
            dbase.setLiveStreamStart(getUnitID(this.props.selectedUnit))
                .then(() => {
                    this.setState(byPropKey('viewStateReady', true));
                })
                .catch(err => {
                    this.setState(byPropKey('viewStateReady', false));
                    this.setState(byPropKey('error', err.message));
                });
        }
    }

    componentWillReceiveProps(nextProps) {
        if (getUnitID(this.props.selectedUnit) !== getUnitID(nextProps.selectedUnit) && isReady(nextProps.selectedUnit)) {
            this.setState(byPropKey('viewStateReady', false));
            dbase.setLiveStreamStart(getUnitID(nextProps.selectedUnit))
                .then(() => {
                    this.setState(byPropKey('viewStateReady', true));
                })
                .catch(err => {
                    this.setState(byPropKey('viewStateReady', false));
                    this.setState(byPropKey('error', err.message));
                });
        } else if (isReady(nextProps.selectedUnit)) {
            this.setState(byPropKey('viewStateReady', true));
        }
    }

    render() {
        return (
            this.props.selectedUnit &&
            getUnitID(this.props.selectedUnit) &&
            getUnitLiveStreamURL(this.props.selectedUnit)
                ? (
                    <div key={getUnitID(this.props.selectedUnit)}>
                        {
                            getUnitLiveStreamStatus(this.props.selectedUnit) &&
                            this.state.viewStateReady &&
                            isReady(this.props.selectedUnit) ?
                                (
                                    <dl8-video
                                        poster="/black.png"
                                        format="MONO_360"
                                        seekable
                                        style={{maxHeight: 'calc(100vh - 250px)', minHeight: 150}}
                                    >
                                        <source src={getUnitLiveStreamURL(this.props.selectedUnit)} type={getRecordingType(getUnitLiveStreamURL(this.props.selectedUnit))} />
                                    </dl8-video>
                                ) :
                                (
                                    <div className="text-center">
                                        <Throbber/>
                                        {
                                            isStarting(this.props.selectedUnit) &&
                                            <p className="mt-3">Starting Recording...</p>
                                        }
                                        {
                                            isRecording(this.props.selectedUnit) &&
                                            <p className="mt-3">Recording...</p>
                                        }
                                    </div>
                                )
                        }
                    </div>
                )
                : null
        );
    }
}

export default LiveViewTab;



// WEBPACK FOOTER //
// ./src/components/unit/liveview/LiveViewTab.jsx